import { combineReducers } from 'redux';

const req = require.context('.', false, /\.js$/);
const reducers = {};

req.keys().forEach(key => {
  const filename = key.match(/[a-zA-Z]+.js$/)[0];
  const reducerName = filename.split('.')[0];
  const exportFn = req(key).default;

  if (exportFn) {
    reducers[reducerName] = exportFn;
  }
});

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./src/store/modules/index.js